module.exports = __webpack_public_path__ + "img/zt_icon.0c8c1dc0.png";